export const languageChineseTraditional = {
    "formating": {
        "main": "主要提示詞",
        "jailbreak": "越獄提示詞",
        "chats": "歷史聊天",
        "lorebook": "Lorebook",
        "globalNote": "全域備註",
        "authorNote": "作者備註",
        "lastChat": "前一次聊天",
        "description": "角色描述",
        "personaPrompt": "使用者提示詞",
        "plain": "基礎提示詞",
        "memory": "Supa/HypaMemory",
        "postEverything": "系統提示詞結束"
    },
    "errors": {
        "toomuchtoken": "錯誤：所需的 Token 數超過了可用的最大上下文大小",
        "unknownModel": "錯誤：無法識別所選的模型",
        "httpError": "錯誤：請求發生錯誤：",
        "noData": "這個檔案看起來不太對，或是資料已經損壞了。",
        "onlyOneChat": "至少需要一個聊天室",
        "alreadyCharInGroup": "該群組中已經有一個同名角色。",
        "noUserIcon": "請先設定您的個人頭像。",
        "emptyText": "文字內容為空。",
        "wrongPassword": "密碼錯誤",
        "networkFetch": "這通常是由於網路連線不穩定或伺服器故障引起的。",
        "networkFetchWeb": "這可能是由 CORS 錯誤引起的。這種情況只會在使用網頁版時發生，因為瀏覽器存在一些限制。請嘗試使用本地版或其他版本的叡甦。",
        "networkFetchPlain": "這可能是一次資料抓取（Fetch）錯誤。請嘗試在設定中關閉強制抓取選項。",
        "requestLogRemoved": "該請求記錄已被刪除。",
        "requestLogRemovedDesc": "當用戶端重新整理或加載時，該請求記錄會被刪除。",
        "vertexAuthError": "缺少 Vertex AI 驗證詳細資料。",
        "coldStorageWriteFailed": "冷儲存寫入失敗。您的聊天資料已被保留。",
        "coldStorageVerifyFailed": "冷儲存驗證失敗。您的聊天資料已被保留。"
    },
    "showHelp": "顯示幫助",
    "help": {
        "model": "此模型是指聊天中使用的主要模型。",
        "submodel": "輔助模型是一個用於分析情感圖片、產生自動建議等的模型，推薦使用 GPT-3.5。",
        "oaiapikey": "OpenAI 的 API 金鑰（Key），可在 https://platform.openai.com/account/api-keys 取得。",
        "mainprompt": "主要提示詞設定用於決定模型的預設行為。",
        "jailbreak": "當角色中的越獄開關被啟動後，越獄提示詞將被使用。",
        "globalNote": "一個對模型行為有強烈影響的備註（也稱為 UJB），適用於所有角色。",
        "autoSuggest": "用於自動建議使用者回應時生成選項的提示詞。",
        "formatOrder": "提示詞的排列順序：越靠下的區塊對模型的影響越大。",
        "forceUrl": "此欄位不為空時，請求將被發送到您所輸入的網址。",
        "tempature": "較低的數值會使角色更緊密地遵循提示詞，但會使回應更制式與機械化。\n較高的數值則會增強角色的創意表現，但回應可能會變得不穩定。",
        "frequencyPenalty": "較高的數值可以避免角色在個別回應中重複使用相同的詞彙，但回應也更容易出現語意混亂。",
        "presensePenalty": "較高的數值可以避免角色在整體對話中重複使用相同的詞彙，但這也可能導致回答失去一致性和穩定性。",
        "sdProvider": "圖片生成提供者。",
        "msgSound": "當角色回應時，播放 *叮* 的提示音",
        "charDesc": "角色的簡要描述。這會影響角色的回應方式。",
        "charFirstMessage": "角色的初始訊息，這會極大地影響角色的回應方式。",
        "charNote": "對模型行為有強烈影響的備註，嵌入到當前角色中，也稱為 UJB。",
        "toggleNsfw": "切換越獄提示詞的開關。",
        "lorebook": "Lorebook 是由使用者創建的 AI 辭典，只有當上下文中包含關鍵字時 AI 才能看到它。",
        "loreName": "Lorebook 的名稱，不影響 AI。",
        "loreActivationKey": "當上下文中包含任一關鍵字時，該條目將被啟用，並啟動相應的提示詞。使用逗號分隔。",
        "loreorder": "插入順序越高，對模型的影響力越大。在啟動大量條目時，也更不容易被截斷。",
        "bias": "Bias 是一組鍵值數據，用於修改某些字串出現的機率。\n其數值範圍可以是 -100 到 100。較高的數值會使該字串更可能出現，較低的數值則降低出現機率。\n另外，在某些模型中，若將數值設為 -101，該字串將被標記為「強制禁止詞」。\n警告：若 Tokenizer 設定有誤，可能無法正常運作。",
        "emotion": "「表情立繪會根據角色情緒顯示對應的圖片。具體的情緒由角色的回應進行分析。您必須輸入情緒名稱作為詞彙*（如：joy, happy, fear 等）*。若存在名為 **neutral** 的情緒，將作為默認情緒。至少需要三張圖片才能正常運作。」",
        "imggen": "分析聊天內容後，將提示套用至 {{slot}}。",
        "regexScript": "正規表達式（Regex Script）是一個自定義工具，用於將符合條件的字串由「IN」替換為「OUT」。\n\n有四種類型選項：\n\n- **修改輸入（Modify Input）**：修改使用者的輸入內容\n\n- **修改輸出（Modify Output）**：修改角色的輸出內容\n\n- **修改請求資料（Modify Request Data）**：在當前聊天資料發送時進行修改\n\n- **修改顯示（Modify Display）**：僅修改顯示的文字，不更改聊天資料\n\n「IN」必須是一個不帶標誌（flags）的正規表達式，且開頭和結尾不包含斜線。\n\n「OUT」是一個可以包含替換模式的字串。這些替換模式如下：\n\n- $$\n\n  - 插入符號「$」\n\n- $&\n\n  - 插入匹配到的子字串\n\n- $`\n\n  - 插入匹配子字串前的部分\n\n- $1\n\n  - 插入第一個匹配群組，可以替換為其他數字（例如 2、3...）\n\n- $(name)\n\n  - 插入命名群組\n\n針對標誌（flags），除了原生支援的標誌之外，還可以使用下列專為進階使用者設計的標誌：\n\n- `<inject>`：將結果注入當前字串中\n- `<move_top>`：將結果移到字串的頂部\n- `<move_bottom>`：將結果移到字串的底部\n- `<repeat_back>`：如果找不到匹配，則使用上一個匹配的結果\n- `<order n>`：設定結果的順序，數值越高顯示越靠前。「n」代表一個數字（例如 `<order 1>`）。如果未設定，默認為 0。\n- `<cbs>`：解析「IN」中的大括號語法\n\n若要與原生標誌結合使用，可以像這樣使用：`gi<cbs><move_top>`。",
        "experimental": "此為實驗性功能，可能不穩定。",
        "oogaboogaURL": "如果您的 WebUI 支援舊版 API，您的 URL 應類似於 *https://.../run/textgen*。\n\n如果您的 WebUI 支援新版 API，您的 URL 應類似於 *https://.../api/v1/generate*，且將使用 API 伺服器作為主機，並在參數中添加 —api。",
        "exampleMessage": "示範對話會影響角色的回應，但不會永久佔用 Token。\n\n對話格式示例：\n\n```\n<START>\n{{user}}: hi\n{{char}}: hello\n<START>\n{{user}}: hi\nHaruhi: hello\n```\n\n```<START>``` 標記了一段新對話的開始。",
        "creatorQuotes": "說明將顯示在初始訊息之上，用於向使用者提供角色說明。此內容不會進入提示詞中。",
        "systemPrompt": "此欄位不為空時，將替換設定中的主要提示詞為此內容。",
        "chatNote": "這是一個強烈影響模型行為的備註，嵌入於當前聊天中，也稱為記憶或 UJB。",
        "personality": "對角色性格的簡要描述。\n\n**不建議使用此欄位，請填寫在角色描述中。**",
        "scenario": "對角色情境的簡要描述。\n\n**不建議使用此欄位，請填寫在角色描述中。**",
        "utilityBot": "啟用後，將忽略主要提示詞、越獄提示詞和其他提示詞。適用於工具型機器人，而非用於角色扮演。",
        "loreSelective": "啟用選擇性模式後，需同時匹配關鍵字與次要關鍵字，方可啟用該條目。",
        "loreRandomActivation": "啟用「使用機率條件」後，若同時符合啟用條目的其他條件，則在每次發送聊天時，該條目將依照設定的機率被使用。",
        "additionalAssets": "在聊天中顯示的額外資源。\n\n - 使用 `{{raw::<資源名稱>}}` 作為路徑。\n - 使用 `{{image::<資源名稱>}}` 作為圖片。\n - 使用 `{{video::<資源名稱>}}` 作為影片。\n - 使用 `{{audio::<資源名稱>}}` 作為音訊。\n    - 建議放置在背景 HTML 中。",
        "superMemory": "SuperMemory 通過向 AI 提供摘要資料來增強角色的記憶能力。\n\nSuperMemory 是一個文本摘要功能，推薦使用 davinci 模型。不建議使用輔助模型，除非它是未經過濾、最大上下文長度超過 2000 Tokens，且具有良好摘要能力的模型。\n\nSuperMemory 提示詞決定了模型如何撰寫摘要。留空將使用預設提示詞，建議保持留空。\n\n完成所有設定後，您可以在角色的設定中啟用此功能。",
        "replaceGlobalNote": "此欄位不為空時，將替換當前的全域備註為此內容。",
        "backgroundHTML": "將 Markdown/HTML 注入到聊天畫面的背景中。\n\n您也可以使用額外資源。例如，您可以使用 {{audio::<資源名稱}} 作為背景音樂。\n\n此外，您還可以與額外資源搭配使用以下格式：\n - {{bg::<資源名稱>}}：將資源設為背景。",
        "additionalText": "只有當 AI 認為有必要時，才會將該段文本添加到角色描述中。您可以在此處放置較長的文本。使用雙換行進行內容分隔。",
        "charjs": "這是一段會與角色一同運行的 JavaScript。詳情請查看：https://github.com/kwaroran/Risuai/blob/main/src/etc/example-char.js\n**出於安全原因，目前不建議使用。這些代碼不會被包含在匯出中。**",
        "romanizer": "Romanizer 是一個將非羅馬字母轉換為羅馬字母的外掛程式，用於減少請求資料時的 Token。這可能會導致輸出結果與原始模型不同。如果已在聊天中使用羅馬字母，不建議啟用。",
        "inlayImages": "啟用後，圖片可嵌入聊天中，並且支援此功能的 AI 將能夠看到它們。",
        "metrica": "Metric Systemizer 是一個外掛程式，會在請求階段將公制單位轉換為英制單位，而在輸出時轉回公制，讓使用者在介面上顯示公制單位，但效能上使用英制單位。如果在聊天中已經使用英制單位，不建議啟用。",
        "lorePlus": "LoreBook+ 是一項實驗性功能。使用向量資料庫（VectorDB），而不僅是字串匹配。目的在於提供更好的機器人創建體驗和更好的匹配效能。",
        "topP": "Top P 是核心採樣（Nucleus Sampling）的機率閾值，模型只會考慮總機率品質達到 top_p 的 Token 結果。",
        "openAIFixer": "OpenAI Fixer 是一個用於修復 OpenAI 部分問題的外掛程式。",
        "sayNothing": "啟用後，如果使用者沒有輸入聊天內容，系統會自動填入 ’say nothing‘。",
        "showUnrecommended": "啟用後，將顯示不建議使用的過時設定。不建議使用這些設定。",
        "imageCompression": "啟用後，在匯出角色時會壓縮圖片。如果動畫圖片無法顯示，請嘗試關閉此選項。",
        "useExperimental": "啟用後，將顯示部分實驗性功能。",
        "forceProxyAsOpenAI": "啟用後，使用反向代理（Reverse proxy）時將強制使用 OpenAI 格式。",
        "forcePlainFetch": "啟用後，將使用瀏覽器的 Fetch API 來替代原生 HTTP 請求。這可能會導致 CORS 錯誤。",
        "autoFillRequestURL": "啟用後，將自動填入請求 URL 以匹配當前模型。",
        "chainOfThought": "啟用後，將在提示詞中添加思維鏈（CoT, Chain-of-Thought）提示。",
        "gptVisionQuality": "此選項用於設定圖片檢測模型的品質。品質越高，檢測越準確，但會使用更多的 Token。",
        "genTimes": "此設定支援模型上的重滾（reroll）回應數量。除第一則回應外，其他回應將作為快取使用，以降低成本。但若未多次重滾回應，可能增加成本。",
        "requestretrys": "此選項用於設定請求失敗時的重試次數。",
        "emotionPrompt": "此選項用於設定情緒檢測的提示詞。留空將使用預設提示詞。",
        "removePunctuationHypa": "啟用後，將在執行 HypaMemory 前移除標點符號。",
        "additionalParams": "此選項允許將附加的參數添加到請求主體（Request body）中。若要排除某些參數，可以將值設為 `{{none}}`。若要添加標頭（Request header）而非主體，可以在鍵前加上 `header::`，如 `header::Authorization`。若要將值作為 JSON，可以在值前加上 `json::`，如 `json::{\"key\":\"value\"}`。其他情況下，系統將自動判定值的類型。",
        "antiClaudeOverload": "若 Claude 過載發生，叡甦會透過繼續相同的提示來阻止它，以減少過載的機率。此功能僅適用於流式回應（Streamed Responses），對非官方 API 端點可能無效。",
        "triggerScript": "觸發式（Trigger）是一個自定義指令碼，在符合條件時執行。可用於修改聊天資料、執行指令、更改變數等。類型取決於觸發時的情況，也可由按鈕觸發，如 {{button::Display::TriggerName}} 或帶有 risu-trigger=\"<TriggerName>\" 屬性的 HTML 按鈕。",
        "autoContinueChat": "啟用後，當聊天不以標點符號結束時，系統將嘗試繼續對話。請勿在不使用標點符號的語言中啟用此功能。",
        "combineTranslation": "啟用後，將把被 HTML 標籤分隔但屬於同一句的文本合併後進行翻譯，並在翻譯結果上重新套用「修改顯示」（Modify Display）。這有助於提高翻譯的準確性。若啟用此後介面出現異常，請關閉此選項並回報問題。",
        "dynamicAssets": "啟用後，若在處理資料時找不到資源名稱，系統將使用向量搜尋（Vector Search）嘗試尋找最接近的資源名稱並進行替換。",
        "dynamicAssetsEditDisplay": "啟用後，動態資源將同樣應用於「修改顯示」階段，但這可能會影響效能。",
        "nickname": "設定後，將在聊天中以此暱稱取代角色名稱，並顯示於 {{char}} 和 <char>。",
        "useRegexLorebook": "啟用後，Lorebook 將改用正規表達式（Regex）搜尋，而不再使用字串匹配。格式為 /regex/flags。",
        "customChainOfThought": "警告：不再建議使用思維鏈（CoT, Chain-of-Thought）切換功能。請將相關提示詞移至其他提示詞欄位。",
        "customPromptTemplateToggle": "可在此處設定自定義提示詞切換功能。使用 `<toggle variable>=<toggle name>` 格式，每行一個，例如：`cot=Toggle COT`。您可以在提示詞中透過 `{{getglobalvar::toggle_<toggle variable>}}` 語法來使用這些切換功能，如：`{{getglobalvar::toggle_cot}}`。",
        "defaultVariables": "可在此處設定自訂預設變數。使用 `<variable name>=<variable value>` 格式，每行一個。例如：`name=叡甦`，可在觸發式和 CBS 變數中使用，如：`{{getvar::A}}`、`{{setvar::A::B}}` 或 `{{? $A + 1}}`。若提示詞範本的預設變數與角色的預設變數名稱相同，系統將使用角色的預設變數。",
        "lowLevelAccess": "啟用後，將開放需要高計算能力的功能，並允許通過角色中的觸發式執行 AI 模型。除非確實需要這些功能，否則不要啟用此選項。",
        "triggerLLMPrompt": "這是將發送到模型的提示詞。您可以使用 `@@role user`、`@@role system`、`@@role assistant` 來設定多輪對話及角色。例如：\n```\n@@role system\nrespond as hello\n@@role assistant\nhello\n@@role user\nhi\n```",
        "legacyTranslation": "啟用後，將使用舊版翻譯方法，在翻譯前對 Markdown 和引號進行預處理，而非在翻譯後處理。",
        "luaHelp": "可使用 Lua 作為觸發式，並可定義 onInput、onOutput 和 onStart 函數。當使用者發送消息時，調用 onInput；當角色發送消息時，調用 onOutput；當對話開始時，調用 onStart。詳情請參閱說明文檔。",
        "claudeCachingExperimental": "Claude 快取是實驗性功能，可減少模型成本。但若在不使用重滾（reroll）回應的情況下啟用，則可能增加成本。實驗性功能可能不穩定，且未來可能會有所變動。",
        "urllora": "可使用模型文件的直接下載鏈接。通過類似 https://sites.google.com/site/gdocs2direct/ 的網站，從 Google Drive 等平台產生直接連接。或者使用 Civitai URL，複製 AIR（格式如 `urn:air:flux1:lora:civitai:180891@776656` 或 `civitai:180891@776656`），並貼上。",
        "v2GetAlertSelect": "選項以 |（管線符號）分隔。",
        "v2RegexTest": "若正規表達式匹配，則返回 1，否則返回 0。",
        "v2Calculate": "計算數學表達式，支援基本運算（+, -, *, /, %, ^）、比較運算符（<, >, <=, >=, =, !=）、邏輯運算符（&&, ||, !）、優先順序括號以及使用 $variableName 格式的變數替換。變數將自動轉換為數字（無效則默認為 0）。",
        "namespace": "命名空間（Namespace）是模組的唯一標識符，用於防止模組衝突，並與預設和其他模組等進行互動。若不確定如何填寫，建議留空。",
        "moduleIntergration": "可在模組整合區域中輸入模組的命名空間（Namespace）來啟用模組。若要啟用多個模組，可用逗號分隔，例如：`module1,module2,module3`。此功能便於高級使用者通過預設靈活運用模組。",
        "customCSS": "自訂 CSS 樣式。若出現問題，可使用 (Ctrl + .) 啟用或禁用。",
        "betaMobileGUI": "啟用後，將在小於 800px 的螢幕上使用測試版行動介面，需重新整理頁面。",
        "enableScrollToActiveChar": "若已啟用，按下快捷鍵或在拖曳角色時按住 Ctrl 鍵將捲動至目前選取的角色。若資料夾已關閉，則會自動開啟。",
        "unrecommended": "這是一個不建議使用的設定。建議關閉。",
        "jsonSchema": "JSON Schema 將在 AI 模型支援時發送給模型。\n\n然而，由於 JSON Schema 學習難度較高，在叡甦中，您可以使用 TypeScript 接口的子集來代替 JSON Schema。叡甦將在運行時進行轉換。例如，如果您想發送如下的JSON：\n\n```js\n{\n  \"name\": \"叡甦\", // name 必須是叡甦，\n  \"age\": 1, // age 必須是數字，\n  \"icon\": \"slim\", // icon 必須是 ’slim‘ 或 ’rounded‘\n  \"thoughts\": [\"Good View!\", \"Lorem\"] // thoughts 必須是字符串數組\n}\n```\n\n您可以使用以下 TypeScript 接口：\n\n```typescript\ninterface Schema {\n  name;\n  age;\n  icon: ’slim‘|’rounded‘\n  thoughts[]\n}\n```\n\n接口名稱不重要。欲了解更多資訊，請參閱 TypeScript 說明文件：https://www.typescriptlang.org/docs/handbook/interfaces.html 。要檢查支持的 TypeScript 子集，請查看以下內容。<details><summary>支持的 TypeScript 子集</summary>\n\n支援的類型包括 `boolean`、`number`、`string` 和 `Array`。高級類型不被支援（如：單元類型、交集類型、聯合類型、可選類型、字面量類型等），除了以下幾種情況：\n\n        - 原始資料型別（Primitive Type）的陣列（Array）：（如 `string[]`、`Array<boolean>`）\n        - 字符串之間的單值類型（Unit Types）：（例如 `’slim‘|’rounded‘`）\n\n        屬性必須在同一行內定義。若一行中有多個屬性，將會產生錯誤。屬性和接口名稱僅可使用拉丁字符，並在 ASCII 範圍內。屬性名稱不得以單引號或雙引號包裹。接口內部不支持嵌套。在定義屬性的行中，不能包含 `{` 或 `}`。如果想使用更高級的類型，請使用 JSON Schema。\n        </details>",
        "strictJsonSchema": "啟用後，某些模型將嚴格遵循提供的 JSON Schema。若禁用，可能會忽略 JSON Schema。",
        "extractJson": "此欄位不為空時，將從回應中提取特定的 JSON 資料。例如：想從回應 `{\"response\": {\"text\": [\"hello\"]}}` 中提取 `response.text[0]`，可以填寫 `response.text.0`。",
        "translatorNote": "可在此處為每個角色添加獨特的翻譯提示，但僅適用於使用 Ax. 模型進行翻譯。要啟用此功能，請在語言設定中包含 `{{slot::tnote}}`。此功能不適用群組聊天。",
        "groupInnerFormat": "用於定義群組聊天中非發言者角色的格式。此欄位不為空時，將使用此格式替代預設格式。若 `Group Other Bot Role` 設定為 `assistant`，該格式也將應用於發言者。",
        "groupOtherBotRole": "用於定義群組聊天中非發言者的角色。",
        "chatHTML": "每個聊天插入的 HTML。\n\n可以使用CBS和特殊標籤。\n- `<risutextbox>`：用於呈現文字的文本框\n- `<risuicon>`：用於顯示使用者或助理的頭像\n- `<risubuttons>`：用於聊天編輯、翻譯等圖示按鈕\n- `<risugeninfo>`：生成訊息按鈕。",
        "systemContentReplacement": "若模型不支援系統提示詞，則使用此格式取代系統提示詞內容。",
        "systemRoleReplacement": "若模型不支援系統角色，將使用此角色取代系統角色。",
        "summarizationPrompt": "用於摘要的提示詞。留空將使用預設提示詞。您也可以使用包含 {{slot}} 的 ChatML 格式來處理聊天數據。",
        "translatorPrompt": "用於翻譯的提示詞。留空將使用默認提示。您還可以使用帶有 {{slot}} 的 ChatML 格式表示目標語言：用 {{slot::content}} 表示內容，用 {{slot::tnote}} 表示翻譯註釋。",
        "translateBeforeHTMLFormatting": "啟用後，將在正規表達式和 HTML 格式化之前翻譯文本。這可能減少 Token 數，但可能破壞格式。",
        "autoTranslateCachedOnly": "啟用自動翻譯選項時，將只自動翻譯使用者先前已翻譯過的訊息。",
        "presetChain": "若欄位不為空，則每次使用者發送訊息時，系統會從此輸入中的預設列表中隨機變更並應用預設設定。預設列表應以逗號分隔，例如 `preset1,preset2`。",
        "legacyMediaFindings": "啟用後，將使用舊版方法尋找媒體資源，而不使用額外的搜尋演算法。",
        "comfyWorkflow": "請輸入 Comfy UI 的 API 工作流程。您可以在 Comfy UI 中點選「Workflow > Export (API)」按鈕以取得您的 API 工作流程。此外，您必須在工作流程文本中加入 {{risu_prompt}}，該佔位符將被 Risu 提供的提示詞替換。",
        "automaticCachePoint": "如果不存在快取點，聊天結束後會自動建立快取點。",
        "experimentalChatCompressionDesc": "壓縮未使用的聊天資料並儲存在單獨的檔案中。這將大幅減少聊天資料的大小，並顯著提升效能，但這是實驗性功能，可能會不穩定，並導致備份功能等出現問題。",
        "promptInfoInsideChatDesc": "啟用後，將在聊天中繼資料中儲存提示詞預設資訊。儲存的資料包括預設名稱、啟用的切換和提示詞文字。這可能會略微增加處理時間和儲存空間的使用。",
        "autoAdjustSchema": "啟用後，將自動調整動態輸出的 JSON Schema。",
        "dynamicMessages": "啟用後，將允許助理連續發送多條訊息，而不是一次一條。",
        "dynamicMemory": "啟用後，助理將在回應時製作記憶筆記。需額外的提示詞才能使用此功能。",
        "dynamicResponseTiming": "啟用後，將動態調整回應時機。",
        "dynamicRequest": "啟用後，將在隨機時機向模型發出請求，而不需等待使用者輸入。",
        "settingsCloseButtonSize": "調整設定視窗右上角關閉(X)按鈕的大小。預設值為24。",
        "showTypingEffect": "啟用後，當助理生成回應時，將顯示打字指示器。",
        "dynamicOutputPrompt": "啟用後，Schema 資訊將包含在請求中。",
        "sourcemapTranslate": "如果啟用，錯誤的堆疊追蹤將使用來源地圖自動翻譯，以顯示原始原始碼位置。這對於偵錯非常有用。",
        "realmDirectOpen": "啟用後，點擊 RisuRealm 預覽中的角色將直接開啟角色描述。",
        "openRouterProviderOrder": "提供商使用順序，優先使用第一個提供商，若該提供商不可用，將使用下一個。詳情請參閱 https://openrouter.ai/docs/guides/routing/provider-selection#ordering-specific-providers",
        "openRouterProviderOnly": "僅使用此列表中的提供商，若所有提供商均不可用，請求將失敗。詳情請參閱 https://openrouter.ai/docs/guides/routing/provider-selection#allowing-only-specific-providers",
        "openRouterProviderIgnore": "忽略此列表中的提供商,若所有提供商均被忽略,請求將失敗。詳情請參閱 https://openrouter.ai/docs/guides/routing/provider-selection#ignoring-providers",
        "additionalPrompt": "啟用提示詞預處理時，這段文字會加在主要提示詞的末尾。預設值是 'The assistant must act as {{char}}. user is {{user}}.'，用於設定基本的角色扮演情境。",
        "hideAllImagesDesc": "隱藏機器人圖示、機器人圖片資源和RisuRealm封面圖片。",
        "embedding": "嵌入模型用於多個功能中的相似度搜尋：\n\n- **長期記憶**: HypaV2, HypaV3, Hanurai Memory 和 SupaMemory (啟用 HypaMemory 時)\n- **附加文本**: 基於上下文匹配角色附加資訊\n- **動態資源**: 當未找到精確匹配時尋找相似的資源名稱\n- **情感圖片**: 當情感方式設定為 'embedding' 時\n- **觸發腳本**: 觸發腳本中的相似度條件\n- **檔案附件**: 在 PDF/TXT/XML 附件中搜尋\n- **Playground**: Playground 中的嵌入測試"
    },
    "setup": {
        "chooseProvider": "選擇 AI 提供者",
        "openaikey": "使用 OpenAI API 金鑰（推薦）",
        "openaiProxy": "OpenAI 反向代理",
        "setupmodelself": "其他／自行設定",
        "inputApiKey": "請在此輸入 API 金鑰",
        "apiKeyhelp": "可在以下取得 API 金鑰：",
        "setupSelfHelp": "歡迎畫面結束後，可前往設定中自行配置。",
        "theme": "選擇介面主題",
        "themeDescWifulike": "不適合在行動裝置上使用",
        "themeDescWifuCut": "適合在行動裝置上使用",
        "themeDescClassic": "適用於所有裝置",
        "texttheme": "設定文字顏色",
        "inputName": "最後，請輸入您的暱稱。",
        "welcome": "歡迎使用 Risu（叡甦）！我將引導您進行設定。請問我該如何稱呼您？",
        "welcome2": "您好，{username}！在開始之前，我會問您一些問題，稍後可在設定中進行修改。\n\n首先，請選擇 AI 提供者。",
        "openRouterProvider": "OpenRouter 提供許多模型，部分免費且未經內容過濾，但品質不如 OpenAI。",
        "hordeProvider": "Horde 提供免費服務，但回應時間較長且品質較低。",
        "setProviderLater": "還有其他提供者，您可以稍後在設定中配置。如想稍後設定，請選擇此選項。",
        "setupOpenAI": "使用 OpenAI，需要取得 API 金鑰（Key）。\n1. 前往 https://beta.openai.com/ \n2. 使用帳號登入 \n3. 前往 https://beta.openai.com/account/api-keys \n4. 點擊「Create New API Key」，並命名金鑰。 \n5. 複製該金鑰。 \n6. 返回叡甦\n7. 貼上金鑰並點擊「發送」。",
        "setupClaude": "使用 Claude，需要取得一個 API 金鑰（Key）。",
        "setupClaudeSteps": [
            "點擊此連結並使用 Google 帳號登錄",
            "輸入您的資料並點擊「繼續」（Continue）",
            "僅在第一個框中輸入任意名稱，然後點擊「建立帳號」（Create Account）",
            "點擊「購買點數」（Buy Credits）",
            "點擊「完成設定」（Complete Setup）",
            "輸入如上圖所示的內容，但國家／地區部分需自行輸入。完成後點擊「繼續」（Continue）",
            "新增付款方式後點擊「繼續」（Continue）",
            "付款完成後，點擊「新增資金」（Add Funds）。最低需新增 5 美元，或設定自動儲值功能",
            "新增資金後，前往控制台頁面，點擊「取得 API 金鑰」（Get API Keys）",
            "點擊「建立 API 金鑰」（Create API Key）",
            "輸入如上圖所示的內容後，點擊「新增」（Add）",
            "複製金鑰，將其貼到此處並發送。"
        ],
        "setupOpenRouter": "使用 OpenRouter 需要獲取 API 金鑰（Key）。 \n1. 前往 https://openrouter.ai/keys\n2. 點擊「Create Key」\n3. 任意命名金鑰名稱。\n4. 複製該金鑰。\n5. 返回叡甦\n6. 貼上金鑰並點擊「發送」。",
        "allDone": "完成所有設定！請稍待片刻。",
        "setupLaterMessage": "歡迎，{username}！您希望我引導您完成設定還是自行設定？",
        "setupMessageOption1": "引導我完成設定",
        "setupMessageOption1Desc": "推薦新使用者使用",
        "setupMessageOption2": "由我自己完成設定",
        "claudeDesc": "Claude 是由 Antropic 開發的 AI 模型，是 OpenAI 的競爭對手。若您希望使用非英語語言，它優於 GPT。",
        "openAIDesc": "OpenAI GPT 是高品質的 AI 模型，但它付費且存在內容審核，在非英語環境下表現較弱。",
        "chooseChatType": "很好！現在請選擇聊天語言。",
        "chooseChatTypeOption1": "全英語",
        "chooseChatTypeOption1Desc": "推薦英語使用者。AI 將使用英語進行輸入和輸出。",
        "chooseChatTypeOption2": "英語處理",
        "chooseChatTypeOption2Desc": "推薦非英語使用者。AI 內部使用英語處理，但輸入輸出為您的語言。",
        "chooseChatTypeOption3": "無語言側重",
        "chooseChatTypeOption3Desc": "AI 將使用您的語言處理，但可能會降低回應品質。",
        "chooseCheapOrMemory": "除此之外，您更傾向於記憶功能還是節省成本？",
        "chooseCheapOrMemoryOption1": "記憶功能",
        "chooseCheapOrMemoryOption1Desc": "AI 會記住更多內容，但費用較高。",
        "chooseCheapOrMemoryOption2": "省錢模式",
        "chooseCheapOrMemoryOption2Desc": "AI 會記住較少內容，但費用更低。",
        "chooseCheapOrMemoryOption3": "平衡",
        "chooseCheapOrMemoryOption3Desc": "AI 記住的內容多於省錢模式，但不及使用記憶功能。",
        "chooseCheapOrMemoryOption4": "無限制",
        "chooseCheapOrMemoryOption4Desc": "AI 會記住幾乎所有內容，但費用極高。",
        "finally": "最後，您是否希望使用進階工具？",
        "finallyOption1": "是",
        "finallyOption1Desc": "使用進階工具會使界面變得更複雜。推薦進階使用者使用。",
        "finallyOption2": "否",
        "finallyOption2Desc": "不使用高級工具將使界面更簡潔。推薦新使用者使用。",
        "igpPrompt": "如果 IGP 提示詞不為空，它將在主要模型請求之後、主要模型執行之後作為情緒模型執行，並將結果添加到主要模型回應之後。"
    },
    "triggerCategories": {
        "Special": "特殊",
        "Control": "控制",
        "Chat": "聊天",
        "Low Level": "底層",
        "Alert": "警報",
        "Lorebook V2": "Lorebook V2",
        "String": "字串",
        "Data": "資料",
        "Array": "陣列",
        "Others": "其他",
        "Deprecated": "已棄用"
    },
    "triggerDesc": {
        "v2Header": "標頭",
        "v2HeaderDesc": "標頭",
        "v2If": "如果",
        "v2IfDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2Else": "否則",
        "v2ElseDesc": "否則",
        "v2EndIndent": "結束縮排",
        "v2EndIndentDesc": "結束縮排",
        "v2SetVar": "設定變數",
        "v2SetVarDesc": "設定變數 {{var}} {{operator}} {{value}}",
        "v2Loop": "無限循環",
        "v2LoopDesc": "無限循環",
        "v2BreakLoop": "中斷循環",
        "v2BreakLoopDesc": "中斷循環",
        "v2RunTrigger": "執行觸發器",
        "v2RunTriggerDesc": "執行觸發器 {{target}}",
        "v2ConsoleLog": "控制台日誌",
        "v2ConsoleLogDesc": "控制台日誌 {{source}}",
        "v2StopTrigger": "停止觸發器",
        "v2StopTriggerDesc": "停止觸發器",
        "v2CutChat": "剪下聊天",
        "v2CutChatDesc": "剪下聊天從 {{start}} 到 {{end}}",
        "v2ModifyChat": "修改聊天",
        "v2ModifyChatDesc": "修改聊天索引 {{index}} 為 {{value}}",
        "v2SystemPrompt": "新增系統提示詞",
        "v2SystemPromptDesc": "新增系統提示詞於 {{location}} 內容為 {{value}}",
        "v2Impersonate": "發送聊天",
        "v2ImpersonateDesc": "作為 {{role}} 發送聊天，內容為 {{value}}",
        "v2Command": "執行命令",
        "v2CommandDesc": "執行命令 {{value}}",
        "v2SendAIprompt": "發送 AI 提示詞",
        "v2SendAIpromptDesc": "發送 AI 提示詞",
        "v2ImgGen": "圖片生成",
        "v2ImgGenDesc": "從 {{value}} 生成圖片，負面提示為 {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "檢查相似度",
        "v2CheckSimilarityDesc": "檢查 {{source}} 與 {{value}} 之間的相似度 => {{outputVar}}",
        "v2RunLLM": "執行模型",
        "v2RunLLMDesc": "從 {{value}} 發送請求到模型 => {{outputVar}}",
        "v2ShowAlert": "顯示警報",
        "v2ShowAlertDesc": "顯示警報 {{value}}",
        "v2ExtractRegex": "提取正規表達式",
        "v2ExtractRegexDesc": "從 {{value}} 中使用正規表達式 {{regexType}} {{regex}} 和旗標 {{flagsType}} {{flags}} 提取文字，並將結果儲存為 {{resultType}} {{result}} => {{outputVar}}",
        "v2RegexTest": "正規表達式測試",
        "v2RegexTestDesc": "使用正規表達式 {{regex}} 和旗標 {{flags}} 測試 {{value}} => {{outputVar}}",
        "v2GetLastMessage": "獲取最後一條訊息",
        "v2GetLastMessageDesc": "獲取最後一條訊息 => {{outputVar}}",
        "v2GetMessageAtIndex": "獲取指定索引的訊息",
        "v2GetMessageAtIndexDesc": "獲取索引為 {{index}} 的訊息 => {{outputVar}}",
        "v2GetMessageCount": "獲取訊息數量",
        "v2GetMessageCountDesc": "獲取訊息數量 => {{outputVar}}",
        "v2GetLorebook": "獲取 Lorebook",
        "v2GetLorebookDesc": "獲取名稱為 {{target}} 的 Lorebook => {{outputVar}}",
        "v2GetLorebookCount": "獲取 Lorebook 數量",
        "v2GetLorebookCountDesc": "獲取 Lorebook 數量 => {{outputVar}}",
        "v2GetLorebookEntry": "透過索引獲取 Lorebook",
        "v2GetLorebookEntryDesc": "透過索引 {{index}} 獲取 Lorebook => {{outputVar}}",
        "v2SetLorebookActivation": "設定 Lorebook 啟用狀態",
        "v2SetLorebookActivationDesc": "設定索引為 {{index}} 的 Lorebook 啟用狀態為 {{value}}",
        "v2GetLorebookIndexViaName": "透過名稱獲取 Lorebook 索引",
        "v2GetLorebookIndexViaNameDesc": "透過名稱 {{name}} 獲取 Lorebook 索引 => {{outputVar}}",
        "v2ModifyLorebook": "修改 Lorebook",
        "v2ModifyLorebookDesc": "修改名稱為 {{target}} 的 Lorebook 內容為 {{value}}",
        "v2LoopNTimes": "循環 N 次",
        "v2LoopNTimesDesc": "循環 {{value}} 次",
        "v2Random": "隨機數",
        "v2RandomDesc": "產生從 {{min}} 到 {{max}} 的隨機數 => {{outputVar}}",
        "v2GetCharAt": "獲取指定位置的字元",
        "v2GetCharAtDesc": "從 {{source}} 中獲取索引 {{index}} 的字元 => {{outputVar}}",
        "v2GetCharCount": "獲取字元數量",
        "v2GetCharCountDesc": "獲取 {{source}} 的字元數量 => {{outputVar}}",
        "v2ToLowerCase": "轉換為小寫",
        "v2ToLowerCaseDesc": "將 {{source}} 轉換為小寫 => {{outputVar}}",
        "v2ToUpperCase": "轉換為大寫",
        "v2ToUpperCaseDesc": "將 {{source}} 轉換為大寫 => {{outputVar}}",
        "v2SetCharAt": "設定指定位置的字元",
        "v2SetCharAtDesc": "將 {{source}} 中索引 {{index}} 的字元設定為 {{value}} => {{outputVar}}",
        "v2SplitString": "分割字串",
        "v2SplitStringDesc": "使用 {{delimiter}} 分割 {{source}} => {{outputVar}}",
        "v2GetCharacterDesc": "獲取角色描述",
        "v2GetCharacterDescDesc": "獲取角色描述 => {{outputVar}}",
        "v2SetCharacterDesc": "設定角色描述",
        "v2SetCharacterDescDesc": "設定角色描述為 {{value}}",
        "v2GetPersonaDesc": "獲取使用者描述",
        "v2GetPersonaDescDesc": "獲取使用者描述 => {{outputVar}}",
        "v2SetPersonaDesc": "設定使用者描述",
        "v2SetPersonaDescDesc": "設定使用者描述為 {{value}}",
        "v2GetReplaceGlobalNote": "獲取替換全域備註",
        "v2GetReplaceGlobalNoteDesc": "獲取替換全域備註 => {{outputVar}}",
        "v2SetReplaceGlobalNote": "設定替換全域備註",
        "v2SetReplaceGlobalNoteDesc": "設定替換全域備註為 {{value}}",
        "v2GetAuthorNote": "獲取作者備註",
        "v2GetAuthorNoteDesc": "獲取作者備註 => {{outputVar}}",
        "v2SetAuthorNote": "設定作者備註",
        "v2SetAuthorNoteDesc": "設定作者備註為 {{value}}",
        "v2Comment": "添加註釋",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "宣告區域變數",
        "v2DeclareLocalVarDesc": "宣告區域變數 {{var}} 初始值為 {{value}}",
        "v2MakeArrayVar": "建立陣列變數",
        "v2MakeArrayVarDesc": "建立陣列變數 {{var}}",
        "v2GetArrayVarLength": "獲取陣列變數長度",
        "v2GetArrayVarLengthDesc": "獲取陣列變數 {{var}} 的長度 => {{outputVar}}",
        "v2GetArrayVar": "獲取陣列變數",
        "v2GetArrayVarDesc": "獲取陣列變數 {{var}} 索引 {{index}} 的值 => {{outputVar}}",
        "v2SetArrayVar": "設定陣列變數",
        "v2SetArrayVarDesc": "設定陣列變數 {{var}} 索引 {{index}} 的值為 {{value}}",
        "v2PushArrayVar": "添加到陣列變數",
        "v2PushArrayVarDesc": "添加 {{value}} 到陣列變數 {{var}}",
        "v2PopArrayVar": "從陣列變數移除並獲取最後一個值",
        "v2PopArrayVarDesc": "從陣列變數 {{var}} 移除最後一個值 => {{outputVar}}",
        "v2ShiftArrayVar": "從陣列變數移除並獲取第一個值",
        "v2ShiftArrayVarDesc": "從陣列變數 {{var}} 移除第一個值 => {{outputVar}}",
        "v2UnshiftArrayVar": "添加到陣列變數開頭",
        "v2UnshiftArrayVarDesc": "添加 {{value}} 到陣列變數 {{var}} 的開頭",
        "v2SpliceArrayVar": "插入到陣列變數指定位置",
        "v2SpliceArrayVarDesc": "插入 {{value}} 到陣列變數 {{var}} 的 {{start}} 位置",
        "v2SliceArrayVar": "切片陣列變數",
        "v2SliceArrayVarDesc": "切片陣列變數 {{var}} 從 {{start}} 到 {{end}} => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "獲取值在陣列變數中的索引",
        "v2GetIndexOfValueInArrayVarDesc": "獲取 {{value}} 在陣列變數 {{var}} 中的索引 => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "從陣列變數移除索引",
        "v2RemoveIndexFromArrayVarDesc": "從陣列變數 {{var}} 移除索引 {{index}} 的值",
        "v2JoinArrayVar": "連接陣列",
        "v2JoinArrayVarDesc": "使用 {{delimiter}} 連接陣列 {{var}} => {{outputVar}}",
        "v2MakeDictVar": "建立字典變數",
        "v2MakeDictVarDesc": "建立字典變數 {{var}}",
        "v2GetDictVar": "獲取字典值",
        "v2GetDictVarDesc": "從字典 {{var}} 獲取鍵 {{key}} 的值 => {{outputVar}}",
        "v2SetDictVar": "設定字典值",
        "v2SetDictVarDesc": "設定字典 {{var}} 中鍵 {{key}} 的值為 {{value}}",
        "v2DeleteDictKey": "刪除字典鍵",
        "v2DeleteDictKeyDesc": "從字典 {{var}} 刪除鍵 {{key}}",
        "v2HasDictKey": "檢查字典鍵",
        "v2HasDictKeyDesc": "檢查字典 {{var}} 是否包含鍵 {{key}} => {{outputVar}}",
        "v2ClearDict": "清空字典",
        "v2ClearDictDesc": "清空字典 {{var}}",
        "v2GetDictSize": "獲取字典大小",
        "v2GetDictSizeDesc": "獲取字典 {{var}} 的大小 => {{outputVar}}",
        "v2GetDictKeys": "獲取字典鍵列表",
        "v2GetDictKeysDesc": "獲取字典 {{var}} 的所有鍵 => {{outputVar}}",
        "v2GetDictValues": "獲取字典值列表",
        "v2GetDictValuesDesc": "獲取字典 {{var}} 的所有值 => {{outputVar}}",
        "v2ConcatString": "連接字串",
        "v2ConcatStringDesc": "連接 {{source1}} 和 {{source2}} => {{outputVar}}",
        "v2GetLastUserMessage": "獲取最後一條使用者訊息",
        "v2GetLastUserMessageDesc": "獲取最後一條使用者訊息 => {{outputVar}}",
        "v2GetLastCharMessage": "獲取最後一條角色訊息",
        "v2GetLastCharMessageDesc": "獲取最後一條角色訊息 => {{outputVar}}",
        "v2GetFirstMessage": "獲取第一條訊息",
        "v2GetFirstMessageDesc": "獲取第一條訊息 => {{outputVar}}",
        "v2GetAlertInput": "獲取警報輸入",
        "v2GetAlertInputDesc": "獲取警報輸入 => {{outputVar}}",
        "v2GetAlertSelect": "獲取警報選擇",
        "v2GetAlertSelectDesc": "獲取警報選擇，顯示 {{display}} 選項 {{value}} => {{outputVar}}",
        "v2UnsupportedTrigger": "不支援的觸發器",
        "v2UnsupportedTriggerDesc": "不支援的觸發器",
        "v2GetDisplayState": "獲取顯示狀態",
        "v2GetDisplayStateDesc": "獲取顯示狀態 => {{outputVar}}",
        "v2SetDisplayState": "設定顯示狀態",
        "v2SetDisplayStateDesc": "設定顯示狀態為 {{value}}",
        "v2UpdateGUI": "更新 GUI",
        "v2UpdateGUIDesc": "更新 GUI",
        "v2UpdateChatAt": "更新指定索引的聊天",
        "v2UpdateChatAtDesc": "重繪索引為 {{index}} 的聊天",
        "v2Wait": "等待",
        "v2WaitDesc": "等待 {{value}} 秒",
        "v2GetRequestState": "獲取請求內容",
        "v2GetRequestStateDesc": "獲取索引為 {{index}} 的請求內容 => {{outputVar}}",
        "v2SetRequestState": "設定請求內容",
        "v2SetRequestStateDesc": "將索引為 {{index}} 的請求內容設定為 {{value}}",
        "v2GetRequestStateRole": "獲取請求角色",
        "v2GetRequestStateRoleDesc": "獲取索引為 {{index}} 的請求角色 => {{outputVar}}",
        "v2SetRequestStateRole": "設定請求角色",
        "v2SetRequestStateRoleDesc": "將索引為 {{index}} 的請求角色設定為 {{value}}",
        "v2GetRequestStateLength": "獲取請求長度",
        "v2GetRequestStateLengthDesc": "獲取請求長度 => {{outputVar}}",
        "v2IfAdvanced": "如果（進階）",
        "v2IfAdvancedDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "快速搜尋聊天",
        "v2QuickSearchChatDesc": "在深度 {{depth}} 內的聊天中以條件 {{condition}} 快速搜尋 {{value}} => {{outputVar}}",
        "v2StopPromptSending": "停止發送提示詞",
        "v2StopPromptSendingDesc": "停止發送提示詞",
        "v2Tokenize": "計算 Token",
        "v2TokenizeDesc": "計算 {{value}} 的 Token => {{outputVar}}",
        "v2GetAllLorebooks": "獲取所有 Lorebook",
        "v2GetAllLorebooksDesc": "獲取所有 Lorebook 提示詞為陣列 => {{outputVar}}",
        "v2GetLorebookByName": "透過名稱獲取 Lorebook 索引",
        "v2GetLorebookByNameDesc": "透過名稱 {{name}} 獲取 Lorebook 索引陣列 => {{outputVar}}",
        "v2GetLorebookByIndex": "獲取 Lorebook",
        "v2GetLorebookByIndexDesc": "獲取索引為 {{index}} 的 Lorebook 提示詞 => {{outputVar}}",
        "v2CreateLorebook": "建立 Lorebook",
        "v2CreateLorebookDesc": "建立名稱為 {{name}}，關鍵字為 {{key}}，內容為 {{content}} 的 Lorebook",
        "v2ModifyLorebookByIndex": "修改 Lorebook",
        "v2ModifyLorebookByIndexDesc": "修改索引為 {{index}} 的 Lorebook，名稱為 {{name}}，關鍵字為 {{key}}，內容為 {{content}}",
        "v2DeleteLorebookByIndex": "刪除 Lorebook",
        "v2DeleteLorebookByIndexDesc": "刪除索引為 {{index}} 的 Lorebook",
        "v2GetLorebookCountNew": "獲取 Lorebook 數量",
        "v2GetLorebookCountNewDesc": "獲取 Lorebook 總數 => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "設定 Lorebook 常駐",
        "v2SetLorebookAlwaysActiveDesc": "將索引為 {{index}} 的 Lorebook 設定為常駐 {{value}}",
        "v2Calculate": "計算",
        "v2CalculateDesc": "計算 {{expression}} => {{outputVar}}",
        "v2ReplaceString": "替換字串",
        "v2ReplaceStringDesc": "使用正規表達式 {{regex}} 將 {{source}} 替換為 {{replacement}} => {{outputVar}}"
    },
    "triggerInputLabels": {
        "value": "值",
        "var": "變數",
        "varName": "變數名稱",
        "outputVar": "輸出變數",
        "name": "名稱",
        "index": "索引",
        "source": "來源",
        "target": "目標",
        "condition": "條件",
        "operator": "運算子",
        "role": "角色",
        "location": "位置",
        "prompt": "提示詞",
        "model": "模型",
        "start": "開始",
        "end": "結束",
        "min": "最小",
        "max": "最大",
        "delimiter": "分隔符",
        "depth": "深度",
        "key": "鍵",
        "alertContent": "警報內容",
        "options": "選項",
        "cmd": "命令",
        "regex": "正規表達式",
        "replacement": "替換內容",
        "flags": "旗標",
        "negPrompt": "負面提示詞",
        "resultFormat": "結果格式",
        "activationKeys": "啟用關鍵字",
        "insertOrder": "插入順序",
        "sysStart": "系統開始",
        "sysHistoryEnd": "系統歷史結束",
        "sysPromptEnd": "系統提示結束",
        "addElse": "添加否則（Else）",
        "alwaysActive": "總是啟用",
        "trigger": "觸發器",
        "triggerOn": "觸發於",
        "valueTypeDesc": "直接使用輸入值",
        "varTypeDesc": "使用儲存在變數中的值",
        "conditionEqual": "等於 (=)",
        "conditionNotEqual": "不等於 (≠)",
        "conditionGreater": "大於 (>)",
        "conditionLess": "小於 (<)",
        "conditionGreaterEqual": "大於或等於 (≥)",
        "conditionLessEqual": "小於或等於 (≤)",
        "conditionSimilar": "相似 (≒)",
        "conditionContains": "包含 (∋)",
        "conditionIn": "在其中 (∈)",
        "conditionNotContains": "不包含 (∌)",
        "conditionNotIn": "不在其中 (∉)",
        "conditionTruthy": "為真 (≡)",
        "operatorSet": "設定 (=)",
        "operatorAdd": "加 (+=)",
        "operatorSubtract": "減 (-=)",
        "operatorMultiply": "乘 (*=)",
        "operatorDivide": "除 (/=)",
        "operatorModulo": "取餘 (%=)",
        "searchLoose": "寬鬆搜尋",
        "searchStrict": "嚴格搜尋",
        "searchRegex": "正規表達式搜尋",
        "modelMain": "主要模型",
        "modelSub": "輔助模型",
        "roleUser": "使用者",
        "roleChar": "角色",
        "roleSystem": "系統",
        "roleAssistant": "助理",
        "boolTrue": "True",
        "boolFalse": "False",
        "boolNull": "Null",
        "helpVarName": "輸入變數名稱",
        "helpOutputVar": "輸入用於儲存結果的變數名稱",
        "helpIndex": "陣列或訊息索引編號",
        "helpRegex": "輸入正規表達式樣式",
        "helpFlags": "正規表達式旗標",
        "helpDelimiter": "用於分割字串的分隔符",
        "helpActivationKeys": "以逗號分隔的啟用關鍵字",
        "helpInsertOrder": "插入順序",
        "helpDepth": "搜尋訊息的深度",
        "helpMinMax": "最小值和最大值範圍",
        "helpSlot": "使用 {{slot}} 保持不變",
        "expression": "表達式"
    },
    "playground": {
        "playground": "Playground",
        "inlayDeleteConfirm": "確定要刪除\"{name}\"嗎？",
        "inlayDeleteMultipleConfirm": "確定要刪除選中的{count}個資源嗎？",
        "inlayDeleteSelected": "刪除選中項",
        "inlayDeselectAll": "取消全選",
        "inlayEmpty": "沒有保存的內聯資源",
        "inlayEmptyDesc": "在聊天中附加或生成的圖像、音頻和視頻將顯示在這裡",
        "inlayExplorer": "內聯資源瀏覽器",
        "inlaySelectAll": "全選",
        "inlayTotalAssets": "共{count}個資源",
    },
    "confirm": "確定",
    "goback": "返回",
    "botSettings": "機器人設定",
    "model": "模型",
    "apiKey": "API 金鑰",
    "providerURL": "請求地址（URL）",
    "providerJSON": "請求主體（JSON）",
    "mainPrompt": "主要提示詞",
    "jailbreakPrompt": "越獄提示詞",
    "globalNote": "全域備註",
    "autoSuggest": "自動建議",
    "tokens": "Tokens",
    "maxContextSize": "最大上下文長度（Max Context Size）",
    "maxResponseSize": "最大回應長度（Max Response Size）",
    "temperature": "溫度（Temperature）",
    "frequencyPenalty": "頻率懲罰（Frequency Penalty）",
    "presensePenalty": "存在懲罰（Presence Penalty）",
    "advancedSettings": "進階設定",
    "advancedSettingsWarn": "警告：若不確定該選項的作用，請勿進行修改！",
    "formatingOrder": "格式順序",
    "authorNote": "作者備註",
    "firstMessage": "初始訊息",
    "description": "描述",
    "note": "說明",
    "jailbreakToggle": "使用越獄提示詞",
    "charIcon": "角色頭像",
    "characterDisplay": "角色展示",
    "viewScreen": "額外角色畫面",
    "none": "無",
    "emotionImage": "表情立繪",
    "noImages": "沒有圖片",
    "noBias": "無 Bias",
    "image": "圖片",
    "name": "名稱",
    "folderName": "資料夾名稱",
    "folderRemoveConfirm": "此資料夾包含世界書。確定要刪除它及其所有內容嗎？",
    "emotion": "情緒名稱",
    "value": "值",
    "reroll": "重新生成",
    "chatList": "聊天列表",
    "removeChat": "確定要移除此訊息嗎？",
    "loreBook": "Lorebook",
    "character": "角色",
    "Chat": "聊天",
    "globalLoreInfo": "角色 Lorebook 適用於該角色的所有對話。",
    "group": "群組",
    "groupLoreInfo": "群組 Lorebook 適用於該群組的所有對話。",
    "localLoreInfo": "聊天 Lorebook 僅用於此對話。",
    "removeConfirm": "您確定要刪除：",
    "removeConfirm2": "您**真的**確定要刪除：",
    "exportConfirm": "您想要匯出此資料嗎？",
    "insertOrder": "插入順序",
    "activationKeys": "關鍵字",
    "activationKeysInfo": "使用逗號分隔",
    "prompt": "提示詞",
    "loreBookDepth": "Lorebook 搜尋深度",
    "loreBookToken": "Lorebook 最大 Token 數",
    "removeCharacter": "刪除角色",
    "removeGroup": "刪除群組",
    "exportCharacter": "匯出角色",
    "userSetting": "使用者設定",
    "username": "您的名稱",
    "userIcon": "您的頭像",
    "successExport": "已成功匯出並保存至您的下載資料夾",
    "successImport": "成功匯入",
    "importedCharacter": "匯入角色",
    "alwaysActive": "始終啟用",
    "additionalPrompt": "附加提示詞",
    "descriptionPrefix": "描述前綴",
    "forceReplaceUrl": "反向代理",
    "emotionWarn": "正在使用輔助模型。",
    "plugin": "外掛程式",
    "language": "語言",
    "UiLanguage": "介面語言",
    "createfromScratch": "自行創建",
    "importCharacter": "匯入角色",
    "translator": "翻譯器",
    "disabled": "關閉",
    "noPluginSelected": "已選擇模型為外掛程式，但未選擇外掛。",
    "text": "文字",
    "UISize": "聊天文字大小",
    "newVersion": "發現更新，是否進行安裝？",
    "remindLaterQuestion": "什麼時候再提醒您？",
    "remindIgnore": "忽略",
    "remindLater1Day": "1天後提醒",
    "remindLater3Days": "3天後提醒",
    "remindLater5Days": "5天後提醒",
    "remindLater1Week": "1週後提醒",
    "display": "顯示 & 音訊",
    "useCustomBackground": "自訂背景",
    "translateInput": "翻譯輸入",
    "autoTranslation": "自動翻譯",
    "fullscreen": "全螢幕",
    "playMessage": "播放訊息音效",
    "iconSize": "頭像大小",
    "createGroup": "建立群組",
    "groupIcon": "群組頭像",
    "single": "單個",
    "multiple": "多個",
    "useCharLorebook": "使用角色 Lorebook",
    "selectChar": "選擇角色",
    "askLoadFirstMsg": "是否載入初始訊息？",
    "theme": "介面主題",
    "editOrder": "編輯順序",
    "autoMode": "自動模式",
    "submodel": "輔助模型",
    "timeOutinSec": "超時時間（秒）",
    "emotionPrompt": "情緒提示詞",
    "singleView": "單角色模式",
    "SpacedView": "多角色模式",
    "emphasizedView": "雙角色模式",
    "pluginWarn": "但安裝惡意外掛可能導致問題。",
    "pluginConfirm": "您真的要導入這個插件嗎？只從可信的來源導入插件。",
    "pluginContainsExternalMedia": "此插件包含外部媒體。",
    "pluginContainsExternalJS": "此插件包含外部 Javascript。",
    "createGroupImg": "產生群組頭像",
    "waifuWidth": "角色對話框寬度",
    "savebackup": "備份至 Google",
    "loadbackup": "從 Google 讀取備份",
    "files": "檔案",
    "backupConfirm": "您確定要保存備份嗎？",
    "backupLoadConfirm": "您確定要讀取備份嗎？所有資料將被覆蓋！",
    "backupLoadConfirm2": "您**真的、真的**確定要加載備份嗎？這將會清除所有資料！",
    "pasteAuthCode": "請從彈出窗口複製驗證碼並貼入：",
    "others": "其他",
    "presets": "預設設定",
    "imageGeneration": "圖片生成",
    "provider": "提供者",
    "key": "金鑰（Key）",
    "noData": "沒有資料",
    "currentImageGeneration": "當前圖片生成數據",
    "promptPreprocess": "使用提示詞預處理",
    "SwipeRegenerate": "使用滑動箭頭重新產生訊息",
    "instantRemove": "刪除訊息時連帶刪除後續訊息",
    "instantRemoveConfirm": "您想只刪除一條訊息嗎？若選擇「否」，後續訊息也將被刪除。",
    "textColor": "文字顏色",
    "classicRisu": "經典 Risu",
    "highcontrast": "高對比度",
    "quickPreset": "可通過 Ctrl +（預設順序編號）快速切換預設。",
    "requestretrys": "請求失敗時重試",
    "utilityBot": "工具機器人",
    "ShowLog": "顯示請求記錄",
    "waifuWidth2": "角色顯示寬度",
    "sayNothing": "無輸入內容時自動填入 ’say nothing‘",
    "regexScript": "正規表達式",
    "type": "類型",
    "editInput": "修改輸入",
    "editOutput": "修改輸出",
    "editProcess": "修改請求資料",
    "loadLatest": "讀取最新的備份",
    "loadOthers": "讀取其他備份",
    "exampleMessage": "示範訊息",
    "creatorNotes": "創建者備註",
    "systemPrompt": "系統提示詞",
    "characterNotes": "角色備註",
    "personality": "性格",
    "scenario": "場景",
    "alternateGreetings": "備選問候語",
    "unrecommended": "不建議",
    "chatNotes": "聊天備註",
    "showUnrecommended": "顯示不建議的設定",
    "altGreet": "備選初始訊息",
    "scripts": "指令碼",
    "settings": "設定",
    "selective": "選擇性",
    "SecondaryKeys": "次要關鍵字",
    "useGlobalSettings": "使用全域設定",
    "recursiveScanning": "遞迴掃描",
    "creator": "創建者",
    "CharVersion": "角色版本",
    "Speech": "語音",
    "ToggleSuperMemory": "啟用 SupaMemory",
    "SuperMemory": "SupaMemory",
    "useExperimental": "啟用實驗性功能",
    "showMemoryLimit": "顯示記憶上限",
    "showFirstMessagePages": "顯示初始訊息分頁",
    "roundIcons": "圓形頭像",
    "streaming": "即時串流傳輸",
    "chatBot": "聊天機器人",
    "otherBots": "其他機器人",
    "user": "使用者",
    "additionalAssets": "額外資源",
    "editDisplay": "修改顯示",
    "community": "社群",
    "textBackgrounds": "自訂文本視窗顏色",
    "textBorder": "文字邊框",
    "textScreenRound": "圓角化文本視窗",
    "textScreenBorder": "文本視窗邊框",
    "ttsReadOnlyQuoted": "僅朗讀引號內容",
    "ttsStop": "停止語音合成",
    "askRemoval": "刪除訊息前進行確認",
    "replaceGlobalNote": "替換全域備註",
    "charLoreBook": "角色 Lorebook",
    "globalLoreBook": "全域 Lorebook",
    "globalRegexScript": "全域正規表達式",
    "accessibility": "輔助功能",
    "sendWithEnter": "使用 Enter 鍵發送（取消檢查時 Shift + Enter 更改為訊息傳送。）",
    "fixedChatTextarea": "固定聊天窗口底部",
    "clickToEdit": "點擊文字進行編輯",
    "enableBlockPartialEdit": "啟用區塊部分編輯（懸停以編輯個別區塊）",
    "enableDragPartialEdit": "啟用拖曳部分編輯（選取文字以編輯）",
    "setNodePassword": "設定密碼以提升安全性",
    "inputNodePassword": "輸入密碼。如果忘記密碼，請刪除伺服器文件中的 save/__password.txt 並重啟伺服器。",
    "simple": "基本",
    "advanced": "進階",
    "askReRollAutoSuggestions": "自動滾動建議",
    "creatingSuggestions": "正在產生建議⋯",
    "orderByOrder": "按順序對話",
    "removeFromGroup": "確定要將 {{char}} 移出群組嗎？",
    "talkness": "健談度",
    "active": "活躍",
    "loreRandomActivation": "啟用機率條件",
    "activationProbability": "機率",
    "shareCloud": "分享至 RisuRealm",
    "hub": "RisuRealm",
    "tags": "標籤",
    "backgroundHTML": "背景嵌入",
    "copied": "已複製",
    "useChatCopy": "啟用聊天訊息複製",
    "useChatSticker": "啟用聊天貼圖",
    "useAdditionalAssetsPreview": "使用額外資源預覽",
    "autoTranslateInput": "自動輸入翻譯",
    "enterMessageForTranslateToEnglish": "輸入訊息以翻譯成英文",
    "recent": "最新",
    "downloads": "下載",
    "trending": "熱門",
    "imageCompression": "圖片壓縮",
    "notLoggedIn": "尚未登入 Risu 帳號",
    "googleDriveInfo": "連接至 Google Drive 以同步資料。",
    "googleDriveConnection": "連接 Google Drive",
    "googleDriveConnected": "已連接 Google Drive",
    "SaveDataInAccount": "保存資料到帳號",
    "dataSavingInAccount": "正在將資料保存到帳號",
    "logout": "登出",
    "loadDataFromAccount": "從帳號讀取資料",
    "saveCurrentDataToAccount": "保存目前資料到帳號",
    "chatAssumed": "",
    "proxyAPIKey": "代理金鑰/密碼",
    "proxyRequestModel": "請求模型",
    "officialWiki": "官方 Wiki",
    "officialWikiDesc": "歡迎查看叡甦官方的 Wiki。",
    "officialDiscord": "官方 Discord",
    "officialDiscordDesc": "叡甦官方的 Discord 伺服器",
    "persona": "使用者資訊",
    "icon": "圖示",
    "account": "帳號",
    "remove": "刪除",
    "able": "啟用",
    "assetWidth": "額外資源圖片最大寬度",
    "animationSpeed": "動畫速度",
    "screenshot": "截圖",
    "screenshotSaved": "截圖已保存",
    "createBotwithAI": "使用 AI 創建機器人",
    "changeFolderName": "輸入新資料夾名稱（留空以取消）",
    "cancel": "取消",
    "renameFolder": "重新命名資料夾",
    "changeFolderColor": "變更資料夾顏色",
    "changeFolderImage": "變更資料夾圖片",
    "fullWordMatching": "完整單詞匹配",
    "botSettingAtStart": "啟動時顯示機器人選單",
    "triggerStart": "聊天發送時觸發",
    "triggerInput": "使用者輸出時觸發",
    "triggerOutput": "角色輸出時觸發",
    "triggerManual": "僅限手動觸發",
    "triggerCondVar": "如果變數為",
    "triggerCondExists": "如果聊天中存在文字",
    "triggerScript": "觸發式",
    "triggerMatchRegex": "與正規表達式匹配",
    "triggerMatchLoose": "寬鬆匹配",
    "triggerMatchStrict": "嚴格匹配",
    "searchDepth": "搜尋深度",
    "equal": "等於",
    "notEqual": "不等於",
    "greater": "大於",
    "less": "小於",
    "greaterEqual": "大於或等於",
    "lessEqual": "小於或等於",
    "triggerEffSysPrompt": "添加系統提示詞",
    "triggerEffSetVar": "修改變數",
    "triggerEffImperson": "發送聊天訊息",
    "triggerEffCommand": "執行指令",
    "triggerEffRunTrigger": "執行觸發式",
    "triggerEffStop": "停止發送提示詞",
    "triggerEffCall": "呼叫觸發式",
    "varableName": "變數名",
    "role": "身份",
    "location": "位置",
    "promptstart": "提示詞開始",
    "promptend": "提示詞結束",
    "historyend": "聊天歷史結束",
    "always": "總是",
    "noEffect": "無效果",
    "invaildTriggerEffect": "此效果不適用於該觸發類型。",
    "operator": "運算符",
    "TriggerSetToVar": "設定為變數",
    "TriggerAddToVar": "增加為變數",
    "TriggerSubToVar": "從變數中減去",
    "TriggerMulToVar": "將變數乘以",
    "TriggerDivToVar": "將變數除以",
    "isNull": "尚未設定",
    "ifChatIndex": "如果對話索引",
    "ifRandom": "如果隨機",
    "ifValue": "如果值",
    "hideRealm": "隱藏 RisuRealm",
    "hideAllImages": "隱藏所有圖片",
    "popularityLevel": "{} 人氣",
    "colorScheme": "配色方案",
    "rangeStart": "範圍開始",
    "rangeEnd": "範圍結束",
    "untilChatEnd": "直到聊天結束",
    "usePromptTemplate": "使用提示詞模板",
    "specialType": "特殊類型",
    "noSpecialType": "無特殊類型",
    "forceProxyAsOpenAI": "強制代理格式為 OpenAI",
    "promptTemplate": "提示詞模板",
    "customInnerFormat": "自訂內部格式",
    "innerFormat": "內部格式",
    "HypaMemory": "HypaMemory",
    "ToggleHypaMemory": "啟動 HypaMemory",
    "resetPromptTemplateConfirm": "您真的確定要重置提示詞模板嗎？",
    "emotionMethod": "情緒檢測方式",
    "continueResponse": "繼續回應",
    "showMenuChatList": "在選單中顯示聊天列表",
    "translatorLanguage": "翻譯目標語言",
    "translatorType": "翻譯器類型",
    "htmlTranslation": "HTML 翻譯",
    "deeplKey": "DeepL API 金鑰",
    "deeplFreeKey": "DeepL 免費 API 金鑰",
    "deeplXUrl": "DeepLX URL",
    "deeplXToken": "DeepLX Token",
    "exportPersona": "匯出使用者設定",
    "importPersona": "匯入使用者設定",
    "export": "匯出",
    "import": "匯入",
    "supporterThanks": "支持者鳴謝",
    "supporterThanksDesc": "感謝您的支持！",
    "donatorPatreonDesc": "為保護隱私，默認不會顯示在名單中。若想顯示您的暱稱，請前往叡甦的 Patreon 頁面並點擊連結按鈕。",
    "useNamePrefix": "使用名稱前綴",
    "textAdventureNAI": "以文字冒險形式運行",
    "appendNameNAI": "附加名稱至 NAI",
    "customStopWords": "自訂停止詞",
    "defaultPrompt": "預設提示詞",
    "additionalText": "額外提示",
    "seed": "Seed",
    "charjs": "角色 JavaScript",
    "depthPrompt": "提示詞深度",
    "largePortrait": "肖像",
    "lorePlus": "LoreBook+",
    "reverseProxyOobaMode": "Ooba 模式",
    "joinMultiUserRoom": "加入使用者多人聊天室",
    "exactTokens": "精確 Tokens",
    "fixedTokens": "估算 Tokens",
    "inlayViewScreen": "內嵌視窗",
    "imgGenPrompt": "圖片生成提示詞",
    "imgGenNegatives": "圖片生成負面提示詞",
    "imgGenInstructions": "系統提示詞",
    "usePlainFetchWarn": "使用 NovelAI 時請關閉此選項，避免出現 CORS 錯誤。",
    "translationPrompt": "翻譯提示詞",
    "translationResponseSize": "翻譯回應長度",
    "webdeeplwarn": "此功能不不建議於網頁版使用，避免出現 CORS 錯誤。",
    "saveBackupLocal": "本地保存備份",
    "loadBackupLocal": "本機讀取備份",
    "topP": "Top P",
    "genTimes": "生成次數",
    "cot": "思維鏈（CoT）",
    "forcePlainFetch": "強制簡單抓取",
    "autoFillRequestURL": "自動填入請求 URL",
    "newOAIHandle": "新的 OpenAI 處理方式",
    "inlayImage": "內嵌圖片功能",
    "nativeAutomark": "實驗性本地自動標記",
    "assistantPrefill": "助理預填充",
    "postEndInnerFormat": "結尾內部格式",
    "sendChatAsSystem": "以系統身份發送訊息",
    "sendName": "非群聊時發送名稱",
    "utilOverride": "實用程式覆寫",
    "template": "模板",
    "chatAsOriginalOnSystem": "以原始身份發送",
    "exportAsDataset": "匯出保存資料為數據集",
    "editTranslationDisplay": "修改翻譯顯示",
    "selectModel": "選擇模型",
    "autoRemoveThoughtTag": "刪除思維標記",
    "customChainOfThought": "自訂思維鏈",
    "maxThoughtTagDepth": "思維標記最大深度",
    "openRouterFallback": "使用回退",
    "openRouterMiddleOut": "使用中間輸出",
    "openRouterProviderOrder": "提供商優先順序",
    "openRouterProviderOnly": "允許的提供商",
    "openRouterProviderIgnore": "忽略的提供商",
    "openRouterSearchModel": "搜尋模型...",
    "openRouterSortByName": "按名稱",
    "openRouterSortByPrice": "按價格",
    "openRouterSortByProvider": "按廠商",
    "openRouterSortAsc": "升序",
    "openRouterSortDesc": "降序",
    "geminiApiKey": "Gemini API 金鑰",
    "removePunctuationHypa": "移除記憶標記",
    "memoryLimitThickness": "記憶上限厚度",
    "inputCardPassword": "輸入角色卡密碼",
    "ccv2Desc": "V2 角色卡是廣泛用於聊天機器人前端的格式。",
    "ccv3Desc": "V3 角色卡是用於聊天機器人前端的新型格式。",
    "realmDesc": "RisuRealm 是叡甦的內容分享平台，您可以將角色分享給其他使用者。",
    "rccDesc": "Risu Refined 角色卡具有密碼保護、完整性驗證等附加功能。",
    "password": "密碼",
    "license": "授權",
    "licenseDesc": "您可以設定下載授權，限制角色卡對提示詞的使用。",
    "passwordDesc": "您可以為角色卡設置密碼，防止未經授權的訪問。",
    "largePersonaPortrait": "使用者肖像",
    "module": "模組",
    "modules": "模組",
    "noModules": "尚未安裝任何模組。",
    "createModule": "建立模組",
    "basicInfo": "基本資料",
    "moduleContent": "模組內容",
    "confirmRemoveModuleFeature": "確定要移除此功能嗎？此操作無法還原。",
    "editModule": "編輯模組",
    "importModule": "匯入模組",
    "download": "下載",
    "edit": "編輯",
    "enableGlobal": "全域啟用",
    "chatModulesInfo": "可選擇開啟或關閉此對話的模組。",
    "sideMenuRerollButton": "側欄選單重新載入",
    "persistentStorage": "永久儲存",
    "persistentStorageSuccess": "儲存已成功永久化",
    "persistentStorageFail": "儲存未能永久化。您是否拒絕了請求，或瀏覽器不支持？",
    "persistentStorageRecommended": "建議使用永久儲存",
    "persistentStorageDesc": "您的瀏覽器支持永久儲存，建議啟用以提升效能和使用者體驗。",
    "enable": "啟用",
    "postFile": "上傳檔案",
    "requestInfoInsideChat": "在聊天中顯示請求資料",
    "inputTokens": "輸入 Tokens",
    "outputTokens": "輸出 Tokens",
    "tokenWarning": "Token 計算可能不精確，僅作參考。",
    "log": "記錄",
    "popularityLevelDesc": "人氣會隨著下載量等增加。3.7 人氣約等於 1 次下載。",
    "additionalParams": "額外參數",
    "heightMode": "高度模式",
    "useAdvancedEditor": "使用進階編輯器",
    "noWaitForTranslate": "不等待翻譯",
    "updateRealm": "更新至 RisuRealm",
    "updateRealmDesc": "您正試圖將角色更新至 RisuRealm。此操作將使角色更新至 RisuRealm，且無法還原。",
    "antiClaudeOverload": "防止 Claude 超載",
    "activeTabChange": "目前的標籤已停用，因其他標籤處於活動中。若要啟動此標籤，請按「確定」。",
    "maxSupaChunkSize": "最大 SupaMemory Chunk 大小",
    "addCharacter": "新增角色",
    "importFromRealm": "從 RisuRealm 選擇",
    "importFromRealmDesc": "RisuRealm 提供超過 1000 位角色",
    "random": "隨機",
    "metaData": "中繼資料",
    "autoContinueMinTokens": "目標 Tokens（自動繼續）",
    "autoContinueChat": "防止不完整回覆（自動繼續）",
    "removeIncompleteResponse": "移除不完整句子",
    "tokenizer": "Tokenizer",
    "chatFormating": "聊天格式",
    "useInstructPrompt": "啟用指令提示詞",
    "hanuraiMemory": "HanuraiMemory",
    "textAreaSize": "輸入欄大小",
    "textAreaTextSize": "輸入欄文字大小",
    "sideBarSize": "側邊欄大小",
    "embedding": "嵌入",
    "syntax": "語法",
    "run": "執行",
    "noMessage": "輸入內容以開始聊天。",
    "combineTranslation": "合併翻譯",
    "dynamicAssets": "動態資源",
    "dynamicAssetsEditDisplay": "在介面上使用動態資源",
    "longTermMemory": "長期記憶",
    "grid": "網格",
    "list": "列表",
    "trash": "垃圾桶",
    "trashDesc": "刪除的角色將移至垃圾桶，可選擇還原或永久刪除。刪除的角色將在 3 天後自動永久刪除。",
    "shareExport": "分享/匯出",
    "risupresetDesc": "Risupreset 是專為叡甦預設設定設計的格式。",
    "risuMDesc": "RisuM 是專為叡甦模組設計的格式。",
    "jsonDesc": "JSON 是一種人機都易於讀寫的格式。",
    "nickname": "暱稱",
    "useRegexLorebook": "使用正規表達式",
    "customPromptTemplateToggle": "自訂開關",
    "defaultVariables": "預設變數",
    "hypaAllocatedTokens": "已分配的 Tokens",
    "hypaChunkSize": "Chunk 大小",
    "hypaV2Desc": "HypaMemory V2 是一種結合摘要資料和向量搜尋的長期記憶系統。",
    "supaDesc": "SupaMemory 是一種使用摘要資料的長期記憶系統。",
    "hanuraiDesc": "HanuraiMemory 是一個使用向量搜尋的記憶系統。",
    "lowLevelAccess": "低層級訪問",
    "resultStoredVar": "儲存結果的變數",
    "triggerEffRunLLM": "執行主要模型",
    "triggerEffectSendAI": "重新發送 AI",
    "triggerEffCheckSim": "檢查相似度",
    "triggerEffShowAlert": "顯示警告",
    "normal": "正常",
    "error": "錯誤",
    "input": "輸入",
    "select": "選擇",
    "options": "選項",
    "alertContent": "警報內容",
    "lowLevelAccessConfirm": "此內容使用低層級訪問，可直接存取 AI 模型和您的儲存資料。您確定要匯入嗎？",
    "triggerLowLevelOnly": "此觸發僅適用於低層級訪問，需在角色或模組的進階設定中啟用低層級訪問。",
    "truthy": "真值",
    "extractRegex": "使用正規表達式提取文字",
    "runImgGen": "執行圖片生成",
    "cutChat": "分割聊天",
    "modifyChat": "修改聊天",
    "regex": "正規表達式",
    "flags": "修飾詞",
    "resultFormat": "結果格式",
    "negPrompt": "負面提示詞",
    "start": "開始",
    "end": "結束",
    "index": "索引",
    "search": "搜尋",
    "goCharacterOnImport": "導入後跳轉至角色頁面",
    "format": "格式",
    "v2Warning": "警告：已停止支援 V2 角色卡，可能會缺失部分資料。",
    "applyModule": "套用模組",
    "successApplyModule": "已成功套用模組",
    "font": "字型",
    "lineHeight": "行距",
    "loadAutoServerBackup": "讀取伺服器自動備份",
    "notCharxWarn": "角色使用多項資源，建議匯出為 CharX 格式以提升相容性。",
    "noPlugins": "未安裝外掛",
    "legacyTranslation": "舊版翻譯",
    "clipboardSuccess": "已複製到剪貼簿",
    "translateContent": "翻譯內容",
    "doNotTranslate": "不進行翻譯",
    "includePersonaName": "包含使用者名稱",
    "hidePersonaName": "隱藏使用者名稱",
    "triggerSwitchWarn": "更改觸發類型後，現有觸發將被清除。您確定要繼續嗎？",
    "codeMode": "程式碼",
    "blockMode": "區塊",
    "helpBlock": "幫助",
    "hideChatIcon": "隱藏頭像",
    "loadInternalBackup": "讀取內部備份",
    "createCopy": "新建副本",
    "bindPersona": "綁定使用者",
    "chatOptions": "聊天選項",
    "doYouWantToBindCurrentPersona": "是否綁定當前使用者至此聊天？",
    "doYouWantToUnbindCurrentPersona": "是否解除此對話中的使用者綁定？",
    "personaBindedSuccess": "使用者綁定已完成",
    "personaUnbindedSuccess": "使用者綁定已解除",
    "parameters": "參數",
    "sizeAndSpeed": "大小與速度",
    "useLegacyGUI": "使用舊版介面",
    "claudeCachingExperimental": "Claude 快取",
    "openClose": "開啟／關閉",
    "hideApiKeys": "隱藏 API 金鑰",
    "unformatQuotes": "禁用引號格式",
    "enableDevTools": "啟用開發者工具",
    "selectFile": "選擇檔案",
    "namespace": "命名空間",
    "moduleIntergration": "模組整合",
    "previewInfo": "此預覽顯示模型處理前的提示詞。",
    "miscTools": "其他工具",
    "promptConvertion": "提示詞轉換",
    "convertionStep1": "選擇與提示詞相關的檔案（支持 Context、Instruct 及 Sampler JSON）",
    "customCSS": "自訂 CSS",
    "betaMobileGUI": "測試版行動介面",
    "enableScrollToActiveChar": "啟用捲動至當前角色",
    "menu": "選單",
    "connectionOpen": "已開啟連線",
    "connectionOpenInfo": "多人聊天室已開啟，您可以將聊天室代碼分享給其他使用者。其他使用者可在 Playground > 加入多人聊天室 > 使用代碼加入。",
    "createMultiuserRoom": "新建多人聊天室",
    "connectionHost": "您是聊天室的主持人。",
    "connectionGuest": "您是聊天室的訪客。",
    "otherUserRequesting": "其他使用者正在請求中，請稍後重試。",
    "jsonSchema": "JSON Schema",
    "enableJsonSchema": "啟用 Schema",
    "strictJsonSchema": "嚴格 Schema",
    "extractJson": "提取 JSON",
    "reloadSession": "發現更新版本的儲存資料，正在重新載入對話⋯",
    "fixMarkdownNewline": "修正 Markdown 換行",
    "customQuotes": "自訂引號",
    "leadingSingleQuote": "上單引號",
    "leadingDoubleQuote": "上雙引號",
    "trailingSingleQuote": "下單引號",
    "trailingDoubleQuote": "下雙引號",
    "translatorNote": "翻譯器備註",
    "formatGroupInSingle": "單一群組格式",
    "groupInnerFormat": "非發言者內部格式",
    "groupOtherBotRole": "群組內非發言者的身份",
    "defineCustomGUI": "自定義界面",
    "chatHTML": "聊天介面 HTML",
    "logShare": "顯示分享記錄按鈕",
    "preview": "預覽",
    "recommended": "推薦",
    "newChat": "新對話",
    "predictedOutput": "預測輸出",
    "systemContentReplacement": "替換系統內容",
    "systemRoleReplacement": "替換系統角色",
    "seperateParameters": "分離參數",
    "seperateParametersEnabled": "啟用分離參數",
    "summarizationPrompt": "摘要提示詞",
    "reSummarizationPrompt": "重新摘要提示詞",
    "translatorPrompt": "翻譯提示詞",
    "translateBeforeHTMLFormatting": "於 HTML 格式化前翻譯",
    "retranslate": "重新翻譯",
    "editTranslation": "編輯翻譯",
    "editTranslationSave": "儲存翻譯",
    "exportTranslationCache": "匯出翻譯快取",
    "exportTranslationCacheSuccess": "翻譯快取匯出成功。",
    "importTranslationCache": "匯入翻譯快取",
    "importTranslationCacheConfirm": "這將把條目合併到翻譯快取中。已有的鍵將被覆蓋。是否繼續？",
    "importTranslationCacheSuccess": "已匯入 {0} 筆翻譯快取。",
    importTranslationCacheFailed: "已匯入{0}個條目，但{1}個條目儲存失敗。儲存空間可能已滿。",
    "exportTranslationCacheEmpty": "翻譯快取為空。",
    clearTranslationCache: "清除翻譯快取",
    clearTranslationCacheSuccess: "翻譯快取已清除。",
    clearTranslationCacheConfirm: "這將刪除所有翻譯快取條目，此操作不可撤銷。是否繼續？",
    "loading": "載入中",
    "autoTranslateCachedOnly": "僅自動翻譯已快取訊息",
    "notification": "使用系統通知",
    "permissionDenied": "權限被您的瀏覽器或操作系統拒絕",
    "customFlags": "自定義修飾詞（Flags）",
    "enableCustomFlags": "啟用自定義修飾詞（Flags）",
    "googleCloudTokenization": "Google Cloud Tokenization",
    "presetChain": "預設鏈",
    "legacyMediaFindings": "舊版媒體發現",
    "staticsDisclaimer": "統計資料基於 2024 年 7 月之後的數據，可能不完全準確。",
    "subtitles": "字幕",
    "subtitlesWarning1": "您必須使用具有音訊／視訊輸入的模型才能使用此功能。",
    "subtitlesWarning2": "您必須使用具有即時串流傳輸功能的模型才能使用此功能。",
    "reset": "重置",
    "assetMaxDifference": "資源最大差異",
    "sourceLanguage": "原文語言",
    "destinationLanguage": "目標語言",
    "noWebGPU": "由於目前的瀏覽器或作業系統不支援 WebGPU，效能將大幅下降。",
    "menuSideBar": "選單側邊欄",
    "home": "首頁",
    "showSavingIcon": "顯示儲存圖示",
    "pluginVersionWarn": "這是 {{plugin_version}} 版本的外掛程式，與當前 Risuai 版本不相容。請更新外掛至 {{required_version}} 版本。",
    "imageTranslation": "圖像翻譯",
    "banCharacterset": "自動重新生成字符集",
    "realmDirectOpen": "在 RisuRealm 中直接開啟角色",
    "showPromptComparison": "顯示提示比較",
    "inlayErrorResponse": "嵌入錯誤回應",
    "triggerOn": "觸發於",
    "noConfig": "無設定",
    "varName": "變數名稱",
    "var": "變數",
    "condition": "條件",
    "trigger": "觸發器",
    "outputVar": "輸出變數",
    "source": "來源",
    "cmd": "命令",
    "sysStart": "系統開始",
    "sysHistoryEnd": "系統歷史結束",
    "sysPromptEnd": "系統提示結束",
    "target": "目標",
    "addElse": "添加否則（Else）",
    "min": "最小",
    "max": "最大",
    "delimiter": "分隔符",
    "deleteCount": "刪除數量",
    "triggerEffRunAxLLM": "執行輔助模型",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 是一個使用摘要和向量搜索的長期記憶系統。",
        "supaMemoryPromptPlaceHolder": "留空以使用預設值",
        "maxMemoryTokensRatioLabel": "最大記憶標記比率（估計）",
        "maxMemoryTokensRatioError": "無法計算最大記憶標記比率",
        "memoryTokensRatioLabel": "記憶標記比率",
        "extraSummarizationRatioLabel": "額外摘要比率",
        "maxChatsPerSummaryLabel": "每個摘要的最大訊息數",
        "recentMemoryRatioLabel": "最近記憶比率",
        "similarMemoryRatioLabel": "相似記憶比率",
        "randomMemoryRatioLabel": "隨機記憶比率",
        "enableSimilarityCorrectionLabel": "啟用相似度校正",
        "preserveOrphanedMemoryLabel": "保留孤立記憶",
        "applyRegexScriptWhenRerollingLabel": "重新生成時應用正則表達式腳本",
        "doNotSummarizeUserMessageLabel": "不要摘要用戶訊息"
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3 數據",
        "resetConfirmMessage": "此操作無法撤銷。您要重置 HypaV3 數據嗎？",
        "resetConfirmSecondMessage": "此操作不可逆。您真的確定要重置 HypaV3 數據嗎？",
        "convertLabel": "尚無摘要，但您可以將 HypaV2 數據轉換為 V3。",
        "convertButton": "轉換為 V3",
        "convertSuccessMessage": "成功將 HypaV2 數據轉換為 V3",
        "convertErrorMessage": "無法將 HypaV2 數據轉換為 V3：{0}",
        "noSummariesLabel": "尚無摘要",
        "searchPlaceholder": "輸入 #N、ID 或搜尋關鍵字",
        "summaryNumberLabel": "摘要 #{0}",
        "deleteThisConfirmMessage": "刪除此摘要？",
        "deleteAfterConfirmMessage": "刪除此摘要之後的所有摘要？",
        "deleteAfterConfirmSecondMessage": "此操作無法撤銷。您確定要這樣做嗎？",
        "translationLabel": "翻譯",
        "rerolledSummaryLabel": "重新生成的摘要",
        "rerolledTranslationLabel": "重新生成的摘要翻譯",
        "connectedMessageCountLabel": "關聯訊息（{0}）",
        "connectedFirstMessageLabel": "第一條訊息",
        "connectedMessageRoleLabel": "{0} 的訊息",
        "connectedMessageNotFoundLabel": "找不到訊息",
        "connectedMessageLoadingError": "載入關聯訊息時出錯：{0}",
        "connectedMessageTranslationLabel": "翻譯",
        "nextSummarizationFirstMessageLabel": "第一條訊息",
        "nextSummarizationNoMessageIdLabel": "無訊息 ID",
        "nextSummarizationLabel": "HypaV3 將摘要 [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "警告：找不到訊息",
        "nextSummarizationLoadingError": "載入下一個摘要目標時出錯：{0}",
        "summarizationConditionLabel": "提示：當輸入標記超過最大上下文大小時，HypaV3 將開始進行摘要處理。",
        "emptySelectedFirstMessageLabel": "警告：選定的第一條訊息為空",
        "unclassified": "未分類",
        "reSummarize": "重新摘要",
        "reSummarizing": "重新摘要中...",
        "reSummarizeResult": "重新摘要結果",
        "retry": "重試",
        "translate": "翻譯",
        "tag": "標籤",
        "tagManager": "標籤管理",
        "tagManagerTitle": "標籤管理 - 摘要 #{0}",
        "newTagName": "新標籤名稱",
        "noTagsYet": "尚無標籤。",
        "addNewTagHint": "在上方新增標籤。",
        "categoryManager": "分類",
        "allCategories": "全部",
        "categoryName": "分類名稱",
        "noCategoriesYet": "尚無分類。",
        "addNewCategoryHint": "點擊上方的 + 按鈕新增。"
    },
    "bulkEnabling": "Lorebook 批次啟用",
    "showTranslationLoading": "顯示翻譯載入中",
    "showDeprecatedTriggerV1": "顯示已棄用的 Trigger V1",
    "showDeprecatedTriggerV2": "顯示已棄用的 Trigger V2",
    "triggerV1Warning": "Trigger V1 已棄用，未來可能會被移除。",
    "copy": "複製",
    "paste": "貼上",
    "depth": "深度",
    "returnCSSError": "返回 CSS 錯誤",
    "alwaysActiveInChat": "始終啟用（當前聊天）",
    "childLoreDesc": "這是角色 Lorebook 的副本，將保持「始終啟用」狀態，直到被移除或在原始設定中手動停用。",
    "thinkingTokens": "思考 Tokens",
    "antiServerOverload": "防止伺服器過載",
    "localActivationInGlobalLorebook": "全域 Lorebook 中的本地啟用",
    "cachePoint": "快取點",
    "all": "全部",
    "showFolderNameInIcon": "在圖示中顯示資料夾名稱",
    "claudeCachingRetrival": "Claude 快取檢索",
    "claudeCachingRetrivalDesc": "透過每 4 分鐘請求一次來延長 Claude 快取的保留時間。這可以降低快取未命中率，但如果不當使用可能會增加成本。",
    "automaticCachePoint": "自動快取點",
    "experimentalChatCompression": "實驗性聊天資料處理",
    "loadingChatData": "正在載入聊天資料",
    "outputImageModal": "輸出圖片模態",
    "playMessageOnTranslateEnd": "翻譯完成後播放音訊",
    "auxModelUnderModelSettings": "在模型設定中顯示輔助模型分離",
    "seperateModelsForAxModels": "為輔助模型使用獨立模型",
    "axModelsDef": "輔助模型定義",
    "doNotChangeSeperateModels": "變更預設時不更改獨立模型設定",
    "tools": "工具",
    "action": "動作",
    "hotkey": "快捷鍵",
    "hotkeyDesc": {
        "reroll": "重新生成",
        "unreroll": "撤銷重新生成",
        "translate": "翻譯",
        "remove": "移除",
        "edit": "編輯",
        "copy": "複製",
        "send": "發送",
        "settings": "設定",
        "home": "首頁",
        "presets": "快速預設選擇",
        "persona": "快速使用者選擇",
        "modelSelect": "快速模型選擇",
        "toggleCSS": "切換 CSS",
        "prevChar": "上一個角色",
        "nextChar": "下一個角色",
        "quickMenu": "快速選單",
        "quickSettings": "快速設定",
        "toggleVoice": "切換語音",
        "toggleLog": "切換日誌",
        "previewRequest": "預覽請求",
        "import": "匯入",
        "export": "匯出",
        "webcam": "切換網路攝影機",
        "focusInput": "聚焦輸入框",
        "scrollToActiveChar": "捲動至當前角色"
    },
    "screenTooSmall": "螢幕太小，無法顯示介面。",
    "advancedModelSettings": "進階模型設定",
    "fallbackModel": "回退模型",
    "fallbackWhenBlankResponse": "回應為空時回退",
    "doNotChangeFallbackModels": "變更預設時不更改回退模型設定",
    "customModels": "自訂模型",
    "igpPrompt": "IGP 提示詞",
    "useTokenizerCaching": "使用 Tokenizer 快取",
    "hypaMemoryV2Modal": "Hypa V2 模態",
    "hypaMemoryV3Modal": "Hypa V3 模態",
    "showMenuHypaMemoryModal": "顯示選單 Hypa 模態",
    "promptInfoInsideChat": "將提示詞資訊加入聊天",
    "promptTextInfoInsideChat": "將提示詞文本加入聊天",
    "promptInfoEmptyMessage": "此訊息沒有可用的提示詞資訊。",
    "promptInfoEmptyToggle": "目前沒有啟用的自訂開關。",
    "promptInfoEmptyText": "尚未儲存提示詞文本。",
    "escapeOutput": "轉義輸出",
    "claudeBatching": "Claude 批次處理",
    "claude1HourCaching": "Claude 1 小時快取",
    "folderNameInput": "請輸入新資料夾名稱",
    "folderRemoveLengthError": "若要移除資料夾，其內容必須為空。",
    "personaNote": "使用者備註",
    "mcpAccessPrompt": "{{tool}} 正在嘗試 \"{{action}}\"。您要允許此操作嗎？",
    "rememberToolUsage": "記住工具使用選擇",
    "simplifiedToolUse": "簡化工具使用",
    "toolCalled": "工具 '{{tool}}' 已被呼叫",
    "static": "靜態",
    "dynamic": "動態",
    "assetStyle": "資源樣式",
    "insertAssetPrompt": "插入資源提示詞",
    "requestLocation": "請求位置",
    "newImageHandlingBeta": "新圖片處理（Beta）",
    "settingsExported": "用於回報錯誤的設定已匯出並複製到剪貼簿。",
    "bookmarks": "書籤",
    "noBookmarks": "無書籤",
    "bookmarkAskNameOrDefault": "輸入書籤名稱。若未輸入，將自動分配名稱。",
    "bookmarkAskNameOrCancel": "輸入書籤名稱。若未輸入，將取消重新命名。",
    "collapseAll": "全部摺疊",
    "expandAll": "全部展開",
    "hideErrorDetails": "隱藏錯誤詳情",
    "showErrorDetails": "顯示錯誤詳情",
    "dynamicOutput": "動態輸出",
    "autoAdjustSchema": "自動調整 Schema",
    "dynamicMessages": "動態訊息",
    "dynamicMemory": "動態記憶",
    "dynamicResponseTiming": "動態回應時機",
    "showTypingEffect": "顯示打字效果",
    "dynamicRequest": "動態請求",
    "dynamicOutputPrompt": "動態輸出提示詞",
    "sourcemapTranslate": "使用來源地圖翻譯堆疊追蹤",
    "settingsCloseButtonSize": "設定關閉按鈕大小",
    "translating": "翻譯中...",
    "showOriginal": "顯示原始程式碼地址",
    "translate": "翻譯程式碼地址",
    "apply": "應用",
    "add": "添加",
    "nightlyWarning": "## Nightly Builds\n\n您正在連接到軟體的 Nightly 版本。此版本僅供測試，很可能包含錯誤。**在此版本中，即使您遇到問題，我們也不支援直接解決。**",
    "loginSionyw": "使用 Sionyw 帳號登入",
    "pluginRiskDetectedAlert": "Risuai 檢測到可能有害的程式碼，可能會**竊取您的 API 金鑰或個人資料**。我們建議您**不要安裝此插件**。",
    "doNotInstall": "不要安裝",
    "continueAnyway": "無論如何都要繼續",
    "pluginNoRiskButAlert": "Risuai 未檢測到有害代碼，但請注意，從不受信任的來源安裝插件可能會帶來安全風險。",
    "pluginRisksInuserFriendly": {
        "eval": "從字串評估代碼",
        "globalAccess": "存取全域變數",
        "thisOutsideClass": "在類別上下文外使用 'this'",
        "errorInVerification": "驗證過程中出錯",
        "storageAccess": "存取儲存空間"
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "插件試圖從字串執行代碼，字串可能被混淆以隱藏惡意代碼。",
        "globalAccess": "插件試圖存取全域變數，這可能導致意外的副作用或安全漏洞。",
        "thisOutsideClass": "插件在類別上下文外使用 'this' 關鍵字，這可能導致意外行為或安全問題。",
        "errorInVerification": "插件驗證過程中出現錯誤，表明其功能可能存在問題。",
        "storageAccess": "插件試圖存取儲存空間，這可能導致資料洩露或未經授權的資料操作。"
    },
    "generatedByAIDisclaimer": "此內容由 AI 生成，可能包含不準確資訊或偏見。",
    "aiGenerationWarning": "內容將由 AI 生成，可能包含不準確資訊或偏見。",
    "autoScrollToNewMessage": "自動捲動至新訊息",
    "alwaysScrollToNewMessage": "始終捲動至新訊息（忽略捲動位置）",
    "newMessage": "新訊息",
    "newMessageButtonStyle": "新訊息按鈕樣式",
    "newMessageButtonBottomCenter": "底部置中 (預設)",
    "newMessageButtonBottomRight": "右下角",
    "newMessageButtonBottomLeft": "左下",
    "newMessageButtonFloatingCircle": "懸浮圓形 (右下角)",
    "newMessageButtonRightCenter": "右中",
    "newMessageButtonTopBar": "頂端列",
    "goToChat": "前往聊天",
    "duplicatePluginFoundUpdateIt": "偵測到重複的外掛程式。您是否要更新現有的外掛程式？",
    "loadMore": "載入更多",
    "pluginUpdateFoundInstallIt": "發現插件更新。是否要安裝此更新？",
    "noRequestLogs": "無請求紀錄。",
    "translateCode": "轉換程式碼位址",
    "branchedText": "此對話已從 {} 分支。",
    "disableMessage": "停用訊息",
    "bookmark": "書籤",
    "branch": "分支",
    "partialBackupFirstConfirm": "⚠️ 警告：部分本地備份 ⚠️\n\n此備份僅快速儲存必要資訊。\n\n包含：\n- 資料庫（聊天記錄、角色、模組、外掛、提示詞、設定等）\n- 角色頭像（主要圖片）\n- 使用者頭像及自訂背景\n- 使用者肖像圖示\n- 資料夾圖片\n- 機器人預設圖片\n\n⚠️ 不包含：\n- 表情圖片\n- 額外角色資源\n- VITS 語音檔案\n- 所有其他額外媒體檔案\n\n此備份不包含所有角色資源！\n如需完整備份，請使用一般本地備份。\n\n是否繼續？",
    "partialBackupSecondConfirm": "⚠️⚠️ 最終警告 ⚠️⚠️\n\n此備份僅儲存角色的頭像圖片，不儲存大多數其他資源！\n\n將儲存：\n- 資料庫（聊天記錄、角色、模組、外掛、提示詞、設定等）\n- 角色頭像（主要圖片）\n- 使用者頭像及自訂背景\n- 使用者肖像圖示\n- 資料夾圖片\n- 機器人預設圖片\n\n不會儲存：\n- 表情圖片\n- 額外角色資源\n- VITS 語音檔案\n- 所有其他媒體檔案\n\n⚠️ 僅在備份檔案不需要角色資源時才繼續！⚠️\n\n您真的確定要進行部分備份嗎？",
    "savePartialLocalBackup": "儲存部分本機備份（不含角色資源）",
    "bootstrap": {
        "dataCorruptionDetected": (name: string, type: string) => `Data Corruption Detected\n\nModule "${name}" has corrupted lorebook format.\n\nCorrupted data type: ${type}`,
        "reportErrorQuestion": "是否要向開發者回報此錯誤？\n這有助於防止相同錯誤再次發生。\n（僅包含損毀模組的資訊，不含個人資料）",
        "diagnosticInformation": (reportData: string) => `# 診斷資訊\n\n請複製以下資訊，並透過 GitHub Issues、Discord 或社群向開發者回報。\n回報前請再次確認是否包含敏感資訊：\n\n\`\`\`json\n${reportData}\n\`\`\``,
        "resetLorebookQuestion": "是否僅重置此損毀模組的 Lorebook 資料？\n（其他模組和角色資料不受影響）\n\n選擇「否」將保留資料，但錯誤可能持續發生。"
    },
    "partialEdit": {
        "editButtonTooltip": "修改",
        "deleteButtonTooltip": "刪除",
        "deleteModalTitle": "刪除確認",
        "deleteConfirmMessage": "確定要刪除此部分嗎？",
        "deleteYes": "確定",
        "deleteNo": "取消",
        "editModalTitle": "部分修改",
        "matchFound": (method: string) => `符合：${method}`,
        "matchFailedTitle": "無法進行部分修改",
        "matchFailedMessage": "無法在原始訊息中精確定位。訊息過長或含有重複內容時可能發生此問題。請改用完整訊息編輯功能。",
        "selectMatch": "選擇要修改的區塊",
        "selectDeleteMatch": "選擇要刪除的區塊",
        "matchesFound": "個符合結果",
        "lineNumber": (line: number) => `約第 ${line} 行`,
        "saveShortcut": "儲存 (Ctrl+Enter)",
        "cancelShortcut": "取消 (Esc)",
        "save": "儲存",
        "cancel": "取消"
    }
} satisfies DeepPartial<typeof import('./en').languageEnglish>;
